var _rect, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckupMitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833008,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#FFE6E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.83301,
    y: 4,
    width: 14,
    height: 14,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6390_32689",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6390_32689",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAhQAAAIUB4uz/wQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAFQSURBVEiJ7dY/L2RhFAbw36AVrGI64guoKER29iOIL0BCwvQr0YhCIUpsRbFKVIRGqdGpNMQ0tpUgEckYxY7inkkm495Bcst5kpPcvOc5z3nPef9d+IUK6jlbBaVCfDxgLxx5oIA5DAjR8hcDe8O+gjLqXW0I3ZjCLm5Qw3NYDdfYCU53lkhPylgXFrGM4RA/xx88BucHRlHCAv5hIybzv1WwuUVFXARpH2NtKmxgHAcRcxEaQrPemmAyiNsZYrOYyfBtR+xkuwSwhTdMpIichqVVUcNm01jmIi/hUlL2YMZsm9GPQ1xJ1u0D0rbpCJ5wjL5IeoaXsDP8Dt9xcEdaNDJb1MC0pKdVvOIE62EnMVYNznRKfBn1tG3awBFWMYQV3Lf4i1jDXXAz8Z2T/B18epJzQSdBJ0EnQfI4VyQv1V/5PvrzkstQCbfy/225xc93E31/aR1AStYAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckupMitter);
export default __webpack_public_path__ + "static/media/checkupMitter.dc2a3199ec70649b62123066ebfbdb63.svg";
export { ForwardRef as ReactComponent };